import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import global from 'styles/global';
import Button from 'components/Button';
import TableHeader from 'components/TableHeader';

import { formatCreatorName } from 'util/renderStrings';
import objectStates from 'constants/objectStates';
import { connect } from 'react-redux';
import {
  invalidateContracts as invalidateContractsSlice,
  remindContracts as remindContractsSlice,
  contractsDictSelector,
  contractsSelector,
} from 'slices/contracts';
import { creatorSelector } from 'slices/user';
import { contractTypes } from 'constants/contracts';
import ContractsTable from 'components/ContractsTable';

const ContractsTab = ({
  contractsDict,
  invalidateContracts,
  sendReminders,
}) => {
  const g = global();
  const history = useHistory();

  const { id } = useParams();
  const creator = useSelector((state) => creatorSelector(state, id));
  const { data: contracts } = useSelector(contractsSelector);

  const contractsForCreator = contracts.filter(
    (contract) => contract.creator_id === creator.id
  );

  const [selectedContracts, setSelectedContracts] = useState([]);

  const handleSendReminders = () => {
    sendReminders(selectedContracts, 'email');
  };

  const handleInvalidateContracts = () => {
    invalidateContracts(selectedContracts);
  };

  // if there are any contracts selected and none are invalidated or signed, then actions are valid
  const areActionsDisabled =
    selectedContracts.length === 0 ||
    selectedContracts.reduce((isDisabled, contractId) => {
      if (isDisabled) return isDisabled;
      const contract = contractsDict[contractId];
      if (!contract) return true;
      if (contract.type !== contractTypes.HelloSign) return true;
      if (
        contract.status === objectStates.canceled ||
        !!contract.signature_date
      )
        return true;
      return false;
    }, false);

  return (
    <div>
      <TableHeader title={`Contracts for ${formatCreatorName(creator)}`}>
        <div>
          <Button
            size="small"
            type="submit"
            variant="outlined"
            color="secondary"
            onClick={handleInvalidateContracts}
            disabled={areActionsDisabled}
          >
            Invalidate
          </Button>
          <Button
            size="small"
            variant="outlined"
            color="primary"
            className={g.ml_xs}
            disabled={areActionsDisabled}
            onClick={handleSendReminders}
          >
            Send email reminder
          </Button>
          <Button
            size="small"
            variant="contained"
            className={g.ml_xs}
            color="primary"
            onClick={() => history.push('/contracts/newContract')}
          >
            New Contract
          </Button>
        </div>
      </TableHeader>
      <div className={g.tableWrapper}>
        <ContractsTable
          autoHeight
          autoPageSize
          contracts={contractsForCreator}
          columnsToDisplay={['title', 'status']}
          checkboxSelection
          disableSelectionOnClick
          onSelectionModelChange={setSelectedContracts}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  contractsDict: contractsDictSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  invalidateContracts: (data) => dispatch(invalidateContractsSlice(data)),
  sendReminders: (ids, method) => dispatch(remindContractsSlice(ids, method)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContractsTab);
